import { render } from "./UnCryptosV1.1.4.vue?vue&type=template&id=f3a13030&scoped=true"
import script from "./UnCryptosV1.1.4.vue?vue&type=script&lang=js"
export * from "./UnCryptosV1.1.4.vue?vue&type=script&lang=js"

import "./UnCryptosV1.1.4.vue?vue&type=style&index=0&id=f3a13030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a13030"]])

export default __exports__